/** Вес важности вопроса: целое от 1 до 5, по умолчанию NORMAL */
export enum EnumWeight {
  LOWEST = 1,
  LOW = 2,
  NORMAL = 3,
  HIGH = 4,
  HIGHEST = 5,
}

export const DEFAULT_WEIGHT = EnumWeight.NORMAL

export function isWeight(value: number): value is EnumWeight {
  return Number.isInteger(value) && value >= EnumWeight.LOWEST && value <= EnumWeight.HIGHEST
}
